module.exports = new __parcel__URL__("water.ee4f3e46.svg").toString();